<template>
  <div class="educa_manage_wrap" v-loading="loading">
    <div class="educa_manage_header">
      <h2>教师管理</h2>
      <div class="operation">
        <el-select v-model="searchForm.structId" @change="searchTeacher" placeholder="请选择组织" clearable>
          <el-option
            v-for="item in organizeList"
            :key="item.structId"
            :label="item.structName"
            :value="item.structId">
          </el-option>
				</el-select>
        <n-search-input v-model="searchForm.teacherName" :placeholder="'请输入账号/姓名/工号/手机号'" @searchInput="searchTeacher(searchForm.teacherName)" style="margin-right:20px"></n-search-input>
        <el-button plain @click="addTeacher()" v-if="$_has('zledu.jiaoxue.teacher.save')">添加教师</el-button>
        <el-button plain @click="uploadTeacher()" v-if="$_has('zledu.jiaoxue.teacher.upload')">导 入</el-button>
        <el-button plain @click="deleteTeacher()" v-if="$_has('zledu.jiaoxue.teacher.delete')">批量删除</el-button>
        <el-button plain @click="examineTeacher()" v-if="$_has('zledu.jiaoxue.teacher.examine')">提交审核</el-button>
      </div>
    </div>
    <div class="educa_manage_table" :style="'padding-bottom:'+(tableData.length?'0':'16')+'px'">
      <n-table
        ref="teacher_manage"
        :tableData="tableData"
        :tableHeader="TeacherTableHeader"
        :ISChangeCheckout="true"
        :TableHeight="TableHeight"
        @operation="operation"
      ></n-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageTotal.currentPage"
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageTotal.pageSize"
        :pager-count="5"
        layout="sizes, prev, pager, next"
        :total="pageTotal.total"
        class="paginator"
        v-if="tableData.length"
      ></el-pagination>
    </div>
    <!-- 添加&编辑教师 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="teacherDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="600px"
      :before-close="handleClose"
      :show-close="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="115px"
      >
        <el-form-item label="账号" prop="username" v-if="ruleForm.id">
          <el-input v-model="ruleForm.username" maxlength="20" disabled placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name" maxlength="20" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="jobNumber">
          <el-input v-model="ruleForm.jobNumber" maxlength="20" placeholder="请输入工号" :disabled="ruleForm.id?true:false"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="cardType">
          <el-select v-model="ruleForm.cardType" placeholder="请选择证件类型" @change="cardTypeChange">
            <el-option label="身份证" value="0"></el-option>
            <el-option label="其他" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号" prop="idCard" v-if="ruleForm.cardType == 0">
          <el-input v-model="ruleForm.idCard" maxlength="18" placeholder="请输入证件号"></el-input>
        </el-form-item>
        <el-form-item label="证件号" prop="other" v-if="ruleForm.cardType == 1">
          <el-input v-model="ruleForm.other" maxlength="30" placeholder="请输入证件号"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-select v-model="ruleForm.roleIds" clearable placeholder="请选择角色" multiple filterable>
            <el-option
              v-for="item in roleList"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属组织" prop="organization">
          <el-select v-model="ruleForm.organization" clearable placeholder="请选择组织">
            <el-option
              v-for="item in organizeList"
              :key="item.structId"
              :label="item.structName"
              :value="item.structId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('ruleForm')">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 导入教师弹出 -->
    <el-dialog title="导入教师名单" :visible.sync="centerDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false" width="600px" :before-close="handleCloseUpload" :show-close="false">
    	<p class="failMsg" v-if="fail*1 > 0">导入成功{{success}}条，失败{{fail}}条<a target="view_frame" @click="jumpFail()">下载查看错误模板信息</a></p>
      <div class="training-site upload-content" v-loading="uploading" element-loading-text="教师名单导入中">
        <div class="left">
            <el-input readonly v-model="fileName"></el-input>
            <span class="on" v-if="fileName" @click="delFile()">删除</span>
            <span class="off" v-else>删除</span>
            <p><i>*</i>注意：</p>
            <p>1.请使用模板文件导入<a target="view_frame" @click="jump()">下载模板</a></p>
        </div>
        <div class="right">
            <el-upload
                ref="upload"
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :before-upload="beforeUpload"
                :show-file-list=false
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList">
                <img src="/static/images/wenjianjia.png" alt="">
                <p>选择文件</p>
            </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleTrainingeSites(false)" :loading="uploading">取 消</el-button>
        <el-button type="primary" @click="handleTrainingeSites(true)" :loading="uploading">保 存</el-button>
      </span>
    </el-dialog>
    <el-drawer
      :title="`编辑（${userInfoInitData.name}）`"
      :visible.sync="showDrawer"
      :wrapper-closable="false"
      :destroy-on-close="true"
      size="80%"
    >
      <teacher-info ref="teacherInfo" v-model="userInfoInitData" :roleList="roleList" :organizeList="organizeList" :dialog-modal="false" style="padding-bottom: 60px"></teacher-info>
      <div class="buttonGroups">
        <el-button @click="showDrawer = false" :loading="uploading">取 消</el-button>
        <el-button type="primary" @click="updateTeacherFn()" :loading="uploading">保 存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import * as api from '@/api/educationalApi'
import { TeacherTableHeader } from "../../../global/table_header_data";
import TeacherInfo from "@/views/szrt_revision/new_educa_module/educa/components/teacherInfo";
import {desensitization} from "@/utils/utils";
export default {
  components: {TeacherInfo},
  data() {
    var checkUserName = (rule, value, callback) => {
      if (value) {
        const reg = /^[a-zA-Z0-9_-]{1,20}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('工号由数字、字母、下划线组成，并且不超过20位'));
        }
      }else if(value==''){
        return callback(new Error('请输入工号'));
      }else{
        callback();
      }
    };
    return {
      showDrawer:false,
      userInfoInitData:{},
      windowHeight: window.innerHeight, // 表格高度根据窗口高度来决定
      searchForm: {
        teacherName: '',
        structId: ""
      },
      loading: true,
      TeacherTableHeader: TeacherTableHeader,
      TableHeight: "0px",
      tableData: [],
      pageTotal: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      multipleSelection: [],
      empty: "暂无数据",
      deptId: sessionStorage.getItem('deptId'),
      roleType: 4,//1-系统管理员、2-机构管理员、4-教师
      roleList: [],//角色列表
      organizeList: [],//组织列表
      teacherDialogVisible: false,//添加&编辑教师
      dialogTitle: '添加教师',
      ruleForm: {
        name: "",
        jobNumber: "",
				cardType: '',
        idCard: '',
        other: '',
        roleIds:[],
        organization: "",
        subjectIds: [],
        id: 0,
        username: "",
        userId: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入教师姓名", trigger: "blur" }],
        jobNumber: [ { required: true, validator: checkUserName, trigger: "blur" }, ],
        idCard: [{ required: true, message: "请输入证件号", trigger: "blur" }],
        other: [{ required: true, message: "请输入证件号", trigger: "blur" }],
        cardType: [{ required: true, message: "请选择证件类型", trigger: "change" }],
        roleIds: [{ required: true, message: "请选择角色", trigger: "change" }],
        organization: [{ required: true, message: "请选择所属组织", trigger: "change" }]
      },
      centerDialogVisible: false,//导入教师
      fileList: [],
      fileName: "",
      file:'',
      uploading:false,
      success:'',
      fail:'',
      uploadUrl:'',
    };
  },
  created() {
    this.queryRole();
    this.queryStructFirstLevel();
    this.getTeacherList();
    let editBtn = {
      name: '编辑',
      emitName: 'edit', // 事件Type 必传
      buttonType: 'text',
    }
    let deleteBtn = {
      name: '删除',
      emitName: 'delete', // 事件Type 必传
      buttonType: 'text',
    }
    let resetBtn = {
      name: '重置密码',
      emitName: 'reset', // 事件Type 必传
      buttonType: 'text',
    }
    let examineBtn = {
      name: '提交审核',
      emitName: 'examine', // 事件Type 必传
      buttonType: 'text',
    }
    let buttons = []
    if(this.$_has('zledu.jiaoxue.teacher.update')){
      buttons.push(editBtn)
    }
    if(this.$_has('zledu.jiaoxue.teacher.delete')){
      buttons.push(deleteBtn)
    }
    buttons.push(resetBtn)
    if(this.$_has('zledu.jiaoxue.teacher.examine')){
      buttons.push(examineBtn)
    }
    this.TeacherTableHeader.forEach(v=>{
      if(v.prop == 'operation'){
        v.SlotType = {
          buttons: buttons
        }
      }
    })
  },
  methods: {
    // 获取所有角色
    queryRole(){
      api.queryRole({
        deptId: this.deptId,
        roleType: this.roleType
      }).then(rs=>{
        if(rs.code==0){
          this.roleList = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    // 获取一级组织
    queryStructFirstLevel(){
      api.queryStructFirstLevel(this.deptId).then(rs=>{
        if(rs.code==0){
          this.organizeList = rs.data
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    // 切换证件切换校验
    cardTypeChange(val){
      if (val == 1){
        this.$set(this.rules, 'other', [{ required: true, message: "请输入证件号", trigger: "blur" }])
        this.$set(this.rules, 'idCard', null)
      }else{
        this.$set(this.rules, 'other', null)
        this.$set(this.rules, 'idCard', [{ required: true, message: "请输入证件号", trigger: "blur" }])
      }
    },
    phoneNumFilter (phone) {//手机号回显
      let phoneArr = [...phone];
      let str = ""
      phoneArr.map((res, index) => {
        if (index > 2 && index < 7) {
          str += '*';
        } else {
          str += res;
        }
      });
      return str;
    },
    IDCardFilter (num) {//身份证回显
      let numArr = [...num];
      let str = ""
      numArr.map((res, index) => {
        if (index > 3 && index < 14) {
          str += '*';
        } else {
          str += res;
        }
      });
      return str;
    },
    // 教师管理列表
    getTeacherList() {
      let that = this
      this.loading = true;
      api.queryNameOrMobilePage({
        type: "1",
        status: "1",
        name: this.searchForm.teacherName,
        page: this.pageTotal.currentPage,
        limit: this.pageTotal.pageSize,
        structId: this.searchForm.structId,
      }).then(res => {
        if(res.code == 0){
          that.tableData = []
          that.TableHeight = "300px"
          let listArr = res.data;
          if(listArr.records.length>0){
            listArr.records.forEach((v,i)=>{
              let obj = v
              let num = (this.pageTotal.currentPage-1) * this.pageTotal.pageSize + i+1
              let idCard = ""
              let mobile = ""
              let auditStatus = ""
              let organizationStr = ""
              idCard = v.idCard ? desensitization(v.idCard) : '——';
              mobile = v.mobile ? desensitization(v.mobile) : '——';
              if(v.auditStatus==0){
                auditStatus = '未提交'
              }else if(v.auditStatus==1){
                auditStatus = '已提交'
              }else if(v.auditStatus==2){
                auditStatus = '审核通过'
              }else if(v.auditStatus==3){
                auditStatus = '未通过'
              }else{
                auditStatus = '未提交'
              }
              if(v.firstStructName){
                organizationStr = v.firstStructName
                if(v.secondStructName){
                  organizationStr += ('-' + v.secondStructName)
                }
              }else{
                // organizationStr = sessionStorage.getItem('deptName')
                organizationStr = ""
              }
              that.$set(obj, 'idCardStr', idCard)
              that.$set(obj, 'mobileStr', mobile)
              that.$set(obj, 'auditStatusStr', auditStatus)
              that.$set(obj, 'organizationStr', organizationStr)
              that.$set(obj, 'num', num)
              that.tableData.push(obj)
            })
            this.pageTotal.total = listArr.total;
            // this.TableHeight = this.tableData.length * 40 + 41 + 'px';
            this.TableHeight = (that.windowHeight - 200) + 'px';
          }
        }else{
          this.$messageError(res.msg);
          return
        }
        this.loading = false;
      }).catch(error => {
        console.log(error);
      });
    },
    handleCurrentChange(val) {//分页
      this.loading = true;
      this.pageTotal.currentPage = val;
      this.getTeacherList()
    },
    handleSizeChange(val){//分页
      this.loading = true;
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.getTeacherList()
    },
    searchTeacher(){// 查询教师
    	this.loading = true;
      this.pageTotal.currentPage = 1;
      this.getTeacherList();
    },
    // 添加教师
    addTeacher() {
      this.rules.jobNumber[0].required = true
      this.dialogTitle = '添加教师'
      this.teacherDialogVisible = true;
    },
    // 关闭弹窗
    handleClose(){
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
        name: "",
        jobNumber: "",
				cardType: '',
        idCard: '',
        other: '',
        roleIds:[],
        organization: "",
        subjectIds: [],
        id: 0,
        username: "",
        userId: 0,
      }
      this.teacherDialogVisible = false;
    },
    // 保存
    handleSubmit(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.addTeacherFn()
        }
      });
    },
    // 编辑教师回显
    editRow(rows){
      this.rules.jobNumber[0].required = false
      this.ruleForm = {
        name: rows.name,
        jobNumber: rows.jobNumber,
				cardType: String(rows.cardType),
        idCard: "",
        other: "",
        roleIds: rows.strRoleIds,
        organization: rows.firstStructId && rows.firstStructId!=0 ? rows.firstStructId : "",
        subjectIds: rows.subjectIds,
        id: rows.id,
        username: rows.userName,
        userId: rows.userId,
      }
      if(rows.cardType==1){
        this.ruleForm.idCard = ""
        this.ruleForm.other = rows.idCard
      }else{
        this.ruleForm.idCard = rows.idCard
        this.ruleForm.other = ""
      }
      this.dialogTitle = '编辑教师'
      this.teacherDialogVisible = true;
    },
    //添加教师-保存
    addTeacherFn(){
      let obj = {
        name: this.ruleForm.name,
        jobNumber: this.ruleForm.jobNumber,
        cardType: this.ruleForm.cardType,
        idCard: this.ruleForm.cardType == 0 ? this.ruleForm.idCard : this.ruleForm.other,
        roleIdList: this.ruleForm.roleIds,
        firstStructId: this.ruleForm.organization,
        subjectIds: [],
        userType: 1,
      }
      api.addTeacher(obj).then(res => {
        if (res.code === "0") {
          this.handleClose()
          this.$messageSuccess("添加教师成功");
          this.getTeacherList();
        } else {
          this.$messageError(res.msg);
        }
      });
    },
    //编辑教师-保存
    async updateTeacherFn(){
      let obj = await this.$refs.teacherInfo.submitForm()
      // obj = {
      //   name: this.ruleForm.name,
      //   jobNumber: this.ruleForm.jobNumber,
      //   cardType: this.ruleForm.cardType,
      //   idCard: this.ruleForm.cardType == 0 ? this.ruleForm.idCard : this.ruleForm.other,
      //   roleIdList: this.ruleForm.roleIds,
      //   firstStructId: this.ruleForm.organization,
      //   subjectIds: this.ruleForm.subjectIds,
      //   userType: 1,
      //   userName: this.ruleForm.userName,
      //   userId: this.ruleForm.userId,
      // }
      api.updateTeacher(obj).then(res => {
        if (String(res.code) === '0') {
          this.$messageSuccess("修改成功");
          this.getTeacherList();
          this.showDrawer = false
        } else {
          this.$messageError('修改失败【'+res.msg+'】');
        }
      });
    },
    // 删除教师
    delRow(rows) {
      this.$confirm("是否确认删除该条教师记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let obj = {
          userIds: [rows.userId],
          userType: 1
        };
        api.deleteUser(obj).then(res => {
          if (res.code === "0") {
            this.$messageSuccess("删除成功");
            if(this.tableData.length == 1 && this.pageTotal.currentPage > 1){
              this.pageTotal.currentPage = this.pageTotal.currentPage - 1;
              this.getTeacherList();
            }else{
              this.getTeacherList();
            }
          } else {
            this.$messageError(res.msg);
          }
        }).catch(error => {
          console.log(error);
        });
      })
    },
    // 批量删除
    deleteTeacher(){
      let obj = {
        "userType": "1",
        "userIds": []
      }
      if(this.multipleSelection.length>0){
        this.multipleSelection.forEach((v,i)=>{
          obj.userIds.push(v.userId)
        })
        this.$confirm("是否确认删除选中的教师记录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(()=>{
          api.deleteUser(obj).then(rs=>{
            if(rs.code==0){
              this.$messageSuccess('删除成功')
              this.getTeacherList()
            }else{
              this.$messageError(rs.msg)
            }
          }).catch(err=>{
            console.log(err)
          })
        }).catch(()=>{

        })
      }else{
        this.$messageWarning('请选择要删除的用户')
      }
    },
    // 重置密码
    resetRow(rows){
      this.$confirm("是否确认重置密码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        api.resetPassword({username:rows.userName}).then((rs)=>{
          if(rs.code==0){
            this.$messageSuccess(rs.msg)
          }else{
            this.$messageError(rs.msg)
          }
        }).then(err=>{
          console.log(err)
        })
      }).catch(()=>{

      });
    },
    // 提交审核
    examineRow(row){
      if(row.auditStatus==1 || row.auditStatus==2){
        this.$messageWarning('请勿重复提交')
        return
      }
      let obj = {
        "auditListReqs": [
          {
            "id": row.id,
            "auditStatus": 1
          }
        ]
      }
      api.submiteAudit(obj).then(rs=>{
        if(rs.code==0){
          this.$messageSuccess('提交审核成功')
          this.getTeacherList()
        }else{
          this.$messageError(rs.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    // 批量提交审核
    examineTeacher(){
      if(this.multipleSelection.length>0){
        let arr = []
        let isRepeat = false
        this.multipleSelection.forEach(val=>{
          if(val.auditStatus==1||val.auditStatus==2){
            isRepeat = true
            return
          }
          arr.push({
            "id": val.id,
            "auditStatus": 1
          })
        })
        if(isRepeat){
          this.$messageWarning('请勿重复提交')
          return
        }
        let obj = {
          "auditListReqs": arr
        }
        api.submiteAudit(obj).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('提交审核成功')
            this.getTeacherList()
          }else{
            this.$messageError(rs.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      }else{
        this.$messageWarning('请选择需要提交审核的教师')
      }
    },
    // table-操作
    operation(type, RowData) {
      if(type=='edit'){
        this.editTeach(RowData)
      }else if(type=='delete'){
        this.delRow(RowData)
      }else if(type=='reset'){
        this.resetRow(RowData)
      }else if(type=='examine'){
        this.examineRow(RowData)
      }else if(type=='selectChange'){
        this.multipleSelection = RowData;
      }
    },
    editTeach(data){
      this.userInfoInitData = data
      this.showDrawer = true
    },
    //=============================导入====================================
    // 导入老师
    uploadTeacher(){
      this.fileName = '';
      this.centerDialogVisible = true;
      this.fail = '';
      this.success = '';
      this.uploadUrl = '';
    },
    beforeUpload(file){
      this.$refs.upload.clearFiles();
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
      const extension2 = testmsg === 'xlsx'
      if(!extension2) {
          this.$messageWarning('上传文件只能是xlsx格式!');
      }else {
      	console.log(file)
          let fd = new FormData();
          fd.append('file', file);
          fd.append('type','1');
					fd.append('platform', '1');
          this.file = fd;
          this.fileName = file.name;
      }
      return extension2
    },
    // 导入老师保存
    handleTrainingeSites(type){
      if(type){
        if(this.fileName){
          this.uploading = true;
          api.importUser(this.file).then(res=>{
            if(res.code == '0'){
              this.loading = true;
              this.getTeacherList();
             	if(res.data.fail > 0){
             		this.uploadUrl = res.data.url;
             		this.success = res.data.success;
             		this.fail = res.data.fail;
             	}else{
             		this.$messageSuccess('导入成功'+res.data.success+'条，失败'+res.data.fail+'条');
             		this.centerDialogVisible = false;
             	}
              this.uploading = false;
            }else{
              this.$messageError('导入的模板错误，请重新导入');
              this.uploading = false;
            }
          })
        }else{
          this.$messageError('请导入名单后再保存');
        }
      }else{
        this.$refs.upload.clearFiles();
        this.centerDialogVisible = false;
      }
    },
    handleExceed(files, fileList) {
      this.$refs.upload.clearFiles();
      // this.$messageWarning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 删除导入文件
    delFile(){
      this.fileName = '';
      this.$refs.upload.clearFiles();
    },
    //下载模板
    jump(){
      let url = process.env.BAK_NAME+'/management/excel/%E5%AF%BC%E5%85%A5%E8%80%81%E5%B8%88%E6%A8%A1%E6%9D%BF.xlsx';
      this.$downloadFun(url)
    },
    //下载查看错误模板信息
    jumpFail(){
    	// window.location.href = this.uploadUrl;
      this.$downloadFun(this.uploadUrl)
    },
    //导出教师关闭
    handleCloseUpload(done){
      done();
      this.$refs.upload.clearFiles();
    },
  }
};
</script>

<style lang="scss" scoped>
.educa_manage_wrap {
  /deep/ .el-dialog{
    .el-dialog__body{
      padding-bottom: 0;
      .el-form{
        .el-input__inner{
          width: 400px;
        }
        .user_name{
          width: 400px;
          display: flex;
          p{
            background: #e8e8e8;
            white-space: nowrap;
            padding: 0 10px;
          }
          .el-input__inner{
            width: inherit;
            border-left: none;
          }
        }
      }
    }
  }
}
.buttonGroups{
  width: 100%;
  position: absolute;
  bottom: 0;
  height: 60px;
  background-color: rgba(255,255,255,0.73);
  display: flex;justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px)
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/teacherManage/teacherAdmin.vue